import { AQISensor, AQISensorObservation } from '../../aqiSensors.types';
import { useAQISensor } from '../useAQISensor';
import { useAQISensorObservations } from '../useAQISensorObservations';

type UseAQISensorWithObservationsProps = {
  id: number;
  start: Date;
  end: Date;
  pollInterval?: number;
};

type UseAQISensorWithObservations = {
  aqiSensor?: AQISensor;
  observations: AQISensorObservation[];
  isLoadingStation: boolean;
  isLoadingObservations: boolean;
  aqiSensorError: Error | null;
  observationsError: Error | null;
};

export const useAQISensorWithObservations = (
  props: UseAQISensorWithObservationsProps,
): UseAQISensorWithObservations => {
  const { id, start, end, pollInterval } = props;

  const {
    aqiSensor,
    isLoading: isLoadingStation,
    error: aqiSensorError,
  } = useAQISensor({ id });

  const {
    observations,
    isLoading: isLoadingObservations,
    error: observationsError,
  } = useAQISensorObservations({ id, start, end, pollInterval });

  return {
    aqiSensor,
    observations,
    isLoadingStation,
    isLoadingObservations,
    aqiSensorError,
    observationsError,
  };
};
